export type CookieConsent = 'accepted' | 'declined';

const STORAGE_KEY = 'yapamar_cookie_consent';

// Session fallback for when localStorage is blocked (e.g. strict private
// browsing): the choice sticks for the current page session instead of the
// banner re-appearing on every navigation, and the visitor is re-asked on
// their next visit — the correct behavior for an unpersistable choice.
let inMemoryConsent: CookieConsent | null = null;

export const getCookieConsent = (): CookieConsent | null => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'accepted' || value === 'declined'
      ? value
      : inMemoryConsent;
  } catch {
    return inMemoryConsent;
  }
};

export const setCookieConsent = (value: CookieConsent) => {
  inMemoryConsent = value;
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage unavailable (e.g. blocked) — the in-memory fallback keeps the
    // choice for this session; the banner will re-appear next visit
  }
};

// Fired on window when the user reopens the consent dialog via the footer
// "Cookie settings" link; the banner listens and re-shows itself
export const COOKIE_CONSENT_RESET_EVENT = 'yapamar:cookie-consent-reset';

export const resetCookieConsent = () => {
  inMemoryConsent = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable — nothing stored to clear
  }
  window.dispatchEvent(new Event(COOKIE_CONSENT_RESET_EVENT));
};
